import { AlertCircle, X } from 'lucide-react';
import { cn } from '../utils/cn';

export interface InlineErrorProps {
  error: string | null | undefined;
  className?: string;
  dismissible?: boolean;
  onDismiss?: () => void;
  onRetry?: () => void;
  retryLabel?: string;
}

export function InlineError({
  error,
  className,
  dismissible = false,
  onDismiss,
  onRetry,
  retryLabel = 'Retry',
}: InlineErrorProps) {
  if (!error) {
    return null;
  }

  return (
    <div role="alert" className={cn('rounded-lg bg-feedback-error/10 border border-feedback-error/30 p-3', className)}>
      <div className="flex items-start gap-3">
        <AlertCircle className="h-5 w-5 text-feedback-error shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <p className="text-sm text-feedback-error">{error}</p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          {onRetry && (
            <button
              type="button"
              onClick={onRetry}
              className="text-xs font-medium text-feedback-error hover:text-action-danger-hover transition-colors"
            >
              {retryLabel}
            </button>
          )}
          {dismissible && onDismiss && (
            <button
              type="button"
              onClick={onDismiss}
              className="rounded p-1 text-feedback-error hover:bg-feedback-error/20 transition-colors"
              aria-label="Dismiss error"
            >
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
